import { motion } from "framer-motion";

export const Field = ({ label, children, hint, error }) => (
  <label className="block">
    <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">{label}</span>
    <div className="mt-2">{children}</div>
    {hint && !error && <span className="mt-1.5 block text-xs text-slate-400">{hint}</span>}
    {error && <span className="mt-1.5 block text-xs text-red-400">{error}</span>}
  </label>
);

export const inputCls =
  "w-full border border-white/10 bg-white/[0.03] px-4 py-3.5 text-base text-bone placeholder:text-slate-500 outline-none transition-[border-color,background-color] duration-300 focus:border-ember focus:bg-white/[0.05]";

export const Choice = ({ active, onClick, icon: Icon, title, text, testId }) => (
  <motion.button
    type="button"
    whileTap={{ scale: 0.97 }}
    onClick={onClick}
    data-testid={testId}
    className={`group relative flex w-full flex-col items-start gap-4 border p-6 text-left transition-[border-color,background-color] duration-300 ${
      active ? "border-ember bg-ember/[0.08]" : "border-white/10 bg-white/[0.02] hover:border-white/30"
    }`}
  >
    {Icon && <Icon className={`h-8 w-8 ${active ? "text-ember" : "text-slate-300"}`} strokeWidth={1.25} />}
    <span>
      <span className="block font-display text-xl font-extrabold">{title}</span>
      {text && <span className="mt-1 block text-sm text-slate-400">{text}</span>}
    </span>
    <span className={`absolute right-4 top-4 h-3 w-3 border ${active ? "border-ember bg-ember" : "border-white/30"}`} />
  </motion.button>
);
